import dynamic from 'next/dynamic';
import { Fragment } from 'react';

const Forms = dynamic(() => import('@/components/Forms/Forms'), { ssr: false });
const AnimatedInfoBalloons = dynamic(
  () => import('@uikit/components/AnimatedInfoBalloons/AnimatedInfoBalloons')
);
const Container = dynamic(
  () => import('@uikit/components/Container/Container')
);
const EegFooter = dynamic(
  () => import('@uikit/components/EegFooter/EegFooter')
);
const EegHeader = dynamic(
  () => import('@uikit/components/EegHeader/EegHeader')
);
const EegModal = dynamic(() => import('@uikit/components/EegModal/EegModal'));
const EegNumberTicker = dynamic(
  () => import('@uikit/components/EegNumberTicker/EegNumberTicker')
);
const EegWindparkMap = dynamic(
  () => import('@uikit/components/EegWindparkMap/EegWindparkMap')
);
const IframeSection = dynamic(
  () => import('@uikit/components/IframeSection/IframeSection')
);
const Section = dynamic(() => import('@uikit/components/Section/Section'));
const SectionVisual = dynamic(
  () => import('@uikit/components/SectionVisual/SectionVisual')
);
const StageBoxText = dynamic(
  () => import('@uikit/components/StageBoxText/StageBoxText')
);
const StageBoxWhite = dynamic(
  () => import('@uikit/components/StageBoxWhite/StageBoxWhite')
);
const TwoColumnContainer = dynamic(
  () => import('@uikit/components/TwoColumnContainer/TwoColumnContainer')
);
const HeroArea = dynamic(() => import('@uikit/composites/HeroArea/HeroArea'));
const SmallHeroArea = dynamic(
  () => import('@uikit/composites/SmallHeroArea/SmallHeroArea')
);

export const CmsComponentsEeg = {
  'eeg-footer': EegFooter,
  'eeg-header': EegHeader,
  'eeg-stage-box-text': StageBoxText,
  'eeg-stage-box-white': StageBoxWhite,
  'eeg-section': Section,
  'eeg-container': Container,
  'eeg-stage-small': SmallHeroArea,
  'eeg-stage': HeroArea,
  'eeg-stage-area': Fragment,
  'eeg-section-visual': SectionVisual,
  'eeg-two-column-container': TwoColumnContainer,
  'eeg-modal': EegModal,
  'eeg-windpark-map': EegWindparkMap,
  'eeg-iframe-section': IframeSection,
  'eeg-forms': Forms,
  'eeg-number-ticker': EegNumberTicker,
  'eeg-animated-info-balloons': AnimatedInfoBalloons,
};
